import { Component, OnInit, Inject } from "@angular/core";
import { FileUploader, FileLikeObject } from "ng2-file-upload";
import { HttpService } from "../../../services/http/http.service";
import { ToastrService } from "ngx-toastr";
import { concat } from "rxjs";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as $ from 'jquery';

@Component({
  selector: "app-upload-documents",
  templateUrl: "./upload-documents.component.html",
  styleUrls: ["./upload-documents.component.css"]
})
export class UploadDocumentsComponent implements OnInit {
  isShow = false;
  fileUploadError = null;
  public uploader: FileUploader = new FileUploader({
    allowedFileType: ['xlsx', 'doc', 'docx', 'pdf', 'gif', 'jpg', 'jpeg', 'png', 'txt', 'image']
  });

  public hasBaseDropZoneOver = false;

  constructor(
    private httpService: HttpService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<UploadDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public popup
  ) {}

  ngOnInit() {
    this.validateFileFormat();
  }

  fileOverBase(event): void {
    this.hasBaseDropZoneOver = event;
  }

  uploadDocuments() {
    this.isShow = true;
    const files = this.getFiles();
    const requests = [];
    files.forEach(file => {
      const formData = new FormData();
      formData.append("patientId", this.popup.patientId);
      formData.append("file", file.rawFile, file.name);
      requests.push(this.httpService.uploadFiles("patient/media", formData));
    });
    let length = requests.length;
    concat(...requests).subscribe(
      res => {
        length--;
        if(length===0){
          this.isShow = false;
          this.toastr.success('Document uploaded successfully', 'Upload Documents', {
            progressBar: true, timeOut: 3000
          });
          this.dialogRef.close();
        }
      },
      err => {
        this.isShow = false;
        this.toastr.warning(err, 'Upload Documents', {
          progressBar: true, timeOut: 3000
        });
      }
    );
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map(fileItem => {
      return fileItem.file;
    });
  }

  onClickUploadFile(e) {
    e.preventDefault();
    $("#selectedFile").click();
  }

  validateFileFormat() {
    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      this.fileUploadError = null;
      switch (filter.name) {
        default:
          this.fileUploadError = `Error trying to upload file ${item.name}`;
          break;
      }
    };
    this.uploader.onAfterAddingFile = item => {
      this.fileUploadError = null;
    };
  }

  onClose() {
    this.dialogRef.close();
  }
}
